// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    padding-bottom: 20px;
}

.header1 {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    font-size: 12px;
    padding: 10px 20px;
}

.header1-backgroud {
    border-radius: 5px;
    background-color: var(--color-light-gray);
    width: 30px;
    height: 30px;
}

.header1-backgroud img {
    width: 30px;
    height: 30px;
}

.header2 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
    padding: 0 20px;
}

.header2-img {
    width: 90%;
}

.header2-1 {
    width: calc(100% - 120px);
    border: 1px solid var(--color-black-muted);
    border-radius: 50px;
    height: 43px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 8px;
    background: linear-gradient(180deg, #212125, #353535, #393939);
}

.header2-1-1 img {
    width: 23px;
}

.header2-1-2 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header2-1-2-2 {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    font-size: 15px;
    font-weight: 500;
    gap: 5px;
}

.header2-1-2-2 img {
    width: 15px;
}

.header2-2 {
    width: 120px;
    background-color: var(--color-darkest-gray);
    border: 2px solid var(--main-color-light);
    border-radius: 50px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    box-shadow: 0px 0px 5px 1px var(--main-color-light)
}

.header2-2-1 {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-size: 12px;
}

.header2-2-1 img {
    width: 25px;
}









.footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding-top: 3px;
    background-color: var(--color-dark-gray);
    z-index: 1000;
}

.footer-box {
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer-box-1 {
    width: 20%;
    font-size: 10px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: var( --color-white);
}

.footer-box-1:active {
    border-radius: 10px;
    background-color: var(--color-gray);
}

.footer-box-1 img {
    width: 24px;
    margin-bottom: 3px;
}

.footer-box-1.active {
    background-color: var(--color-charcoal);
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Nav/nav.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yCAAyC;IACzC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,0CAA0C;IAC1C,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,8DAA8D;AAClE;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,2CAA2C;IAC3C,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;;;;;;;;;AAUA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;AACvB","sourcesContent":[".header {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    z-index: 1000;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.header1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    font-size: 12px;\r\n    padding: 10px 20px;\r\n}\r\n\r\n.header1-backgroud {\r\n    border-radius: 5px;\r\n    background-color: var(--color-light-gray);\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.header1-backgroud img {\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n\r\n.header2 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n    font-size: 14px;\r\n    padding: 0 20px;\r\n}\r\n\r\n.header2-img {\r\n    width: 90%;\r\n}\r\n\r\n.header2-1 {\r\n    width: calc(100% - 120px);\r\n    border: 1px solid var(--color-black-muted);\r\n    border-radius: 50px;\r\n    height: 43px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 8px;\r\n    background: linear-gradient(180deg, #212125, #353535, #393939);\r\n}\r\n\r\n.header2-1-1 img {\r\n    width: 23px;\r\n}\r\n\r\n.header2-1-2 {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n\r\n.header2-1-2-2 {\r\n    display: flex;\r\n    align-items: center;\r\n    /* justify-content: center; */\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    gap: 5px;\r\n}\r\n\r\n.header2-1-2-2 img {\r\n    width: 15px;\r\n}\r\n\r\n.header2-2 {\r\n    width: 120px;\r\n    background-color: var(--color-darkest-gray);\r\n    border: 2px solid var(--main-color-light);\r\n    border-radius: 50px;\r\n    height: 44px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 10px;\r\n    box-shadow: 0px 0px 5px 1px var(--main-color-light)\r\n}\r\n\r\n.header2-2-1 {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 5px;\r\n    font-size: 12px;\r\n}\r\n\r\n.header2-2-1 img {\r\n    width: 25px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n.footer {\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    padding-top: 3px;\r\n    background-color: var(--color-dark-gray);\r\n    z-index: 1000;\r\n}\r\n\r\n.footer-box {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.footer-box-1 {\r\n    width: 20%;\r\n    font-size: 10px;\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    color: var( --color-white);\r\n}\r\n\r\n.footer-box-1:active {\r\n    border-radius: 10px;\r\n    background-color: var(--color-gray);\r\n}\r\n\r\n.footer-box-1 img {\r\n    width: 24px;\r\n    margin-bottom: 3px;\r\n}\r\n\r\n.footer-box-1.active {\r\n    background-color: var(--color-charcoal);\r\n    border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
